module.exports = __webpack_public_path__ + "img/end-img.07ad5da5.png";